/* eslint-disable react/require-default-props, react/display-name */
import React, { memo } from 'react';
import { Box, Button, ButtonGroup, IconButton, Text } from '@chakra-ui/core';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import i18n from '../../../locales/i18n';
import { ReactComponent as _IconCalendar } from '../../../assets/img/icon-calendar-blue.svg';
import { AppointmentAvailability } from '../../../firebase/firestore/documents/appointmentAvaiability';

const IconCalendar = memo(_IconCalendar);

type DateSectionProps = {
  startDate: Date | null | undefined;
  scheduleDetail?: AppointmentAvailability;
  onChange: (date: Date) => void;
};

const CustomDatePickerInput = React.forwardRef<HTMLInputElement, React.HTMLProps<HTMLInputElement>>((props, ref) => (
  <ButtonGroup
    className={`customDatepicker ${props.disabled ? 'disabled' : ''}`}
    size="sm"
    isAttached
    variant="outline"
    onClick={props.onClick}
    ref={ref}
  >
    <IconButton aria-label="calendar" icon={<IconCalendar width={30} height={30} />} />
    <Button mr="-px" isFullWidth>
      {props.value}
    </Button>
  </ButtonGroup>
));

export const DateSelection = ({ startDate, scheduleDetail, onChange }: DateSectionProps): JSX.Element => {
  const { t } = useTranslation('calendar');
  const isDisabled = !!startDate && !!scheduleDetail?.id;

  return (
    <Box className="event-form-control date-picker-box">
      <Text mb={2}>{t('availabilityForm.appointmentDateLabel')}</Text>
      <Box className="date-input-group" zIndex={5}>
        <DatePicker
          locale={i18n.language}
          customInput={React.createElement(CustomDatePickerInput, { disabled: isDisabled })}
          selected={startDate}
          minDate={moment().toDate()}
          disabled={isDisabled}
          dateFormat="P"
          onChange={/* istanbul ignore next */ (date) => onChange(date as Date)}
        />
      </Box>
    </Box>
  );
};
